import React, { useState } from 'react'
import {
  View,
  SafeAreaView,
  Dimensions,
  StatusBar,
  Platform,
} from 'react-native'
import PropTypes from 'prop-types'
import { Icon, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'

import images from '../../Themes/Images'

import styles from './VDay.Styles'

const { height: SCREEN_HEIGHT } = Dimensions.get('window')

const cLoaderColors = {
  background: '#f3f3f3',
  foreground: '#ecebeb',
}

function VDay({
  loading,
  isVisible,
  toggleModal,
  navigateToVdayOffers,
}) {

  const changeStatusBar = (barStyle = 'light-content', backgroundColor = Colors.thinDark, translucent = false) => {
    StatusBar.setBarStyle(barStyle, true)
    Platform.OS === 'android' && StatusBar.setBackgroundColor(backgroundColor, true)
    StatusBar.setTranslucent(translucent)
  }

  const [height, setHeight] = useState(SCREEN_HEIGHT * 0.8 - 32)

  const changeheight = event => {
    const { height: contentHeight } = event.layout
    if (contentHeight < height) {
      setHeight(contentHeight)
    }
  }

  const closeModal = () => {
    changeStatusBar()
    toggleModal()
  }

  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={closeModal}
      type="secondary"
      title="vday_modal_title"
    >
      <View
        style={styles.modal}
        onLayout={({ nativeEvent }) => changeheight(nativeEvent)}
        onStartShouldSetResponder={() => true}
      >

        <Icon
          name={images.reward}
          size={100}
          type="image"
          resizeMode="contain"
          style={styles.reward}
        />

        <VfText
          size="h2"
          weight="bold"
          i18nKey={'vday_title'}
          style={styles.title}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
        />

        <VfText
          size="h4"
          weight="light"
          i18nKey={'vday_description'}
          style={styles.description}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
        />

        <VFButton
          type="primary"
          title="vday_check_button"
          onPress={() => navigateToVdayOffers()}
          style={styles.button}
          disabled={false}
          isLoading={false}
        />

      </View>
    </QuickActionMenu>
  )
}

VDay.defaultProps = {}

VDay.propTypes = {
  loading: PropTypes.bool,
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  navigateToVdayOffers: PropTypes.func,
}

export default VDay
